module.exports = __webpack_public_path__ + "img/copingpatternsoldier.14c16009.png";